import { dashboardSections, rumEvents } from "../index";

const rumEventsGroups = {
  [dashboardSections.OVERVIEW]: [rumEvents.PERFORMANCE_NAVIGATION_EVENT, rumEvents.CONNECT_DEVICE],
  [dashboardSections.FIRMWARE]: [
    rumEvents.FIRMWARE_UPDATE,
    rumEvents.FIRMWARE_UPDATE_DEVICE_RECONNECTION
  ],
  [dashboardSections.DIAGNOSTIC]: [rumEvents.ADVANCED_DIAGNOSTIC_COMPLETED, rumEvents.ADVANCED_DIAGNOSTIC_PROCESS],
  [dashboardSections.SETTINGS]: [rumEvents.SETTINGS],
  [dashboardSections.BATTERY_HEALTH]: [rumEvents.BATTERY_HEALTH]
};

export default rumEventsGroups;
